<span [innerHTML]="key | translate : params : currentLanguage | map : replaceLinkWithTag"></span>
